import { Dropdown } from "antd";
import { BsThreeDots } from "react-icons/bs";
import moment from "moment/moment";

import Panel from "../Panel";
import { Body, Column, ColumnHeader, Row, RowHeader, Table } from "./Table";
import { Link, useLoaderData } from "react-router-dom";
import { formatNaira } from "../../FormatMoney";
import usePagination from "../Table/usePagination";

const LoanDibursed = () => {
  const data = useLoaderData();
  const paidLoanData = data?.paidRequests?.data?.data;
  console.log("paidLoanData payment data", paidLoanData)

  const { Next, Prev, Button, Pagination, setPage, PageSize, Description } =
    usePagination();
    if (paidLoanData?.length < 1) {
      return <div>No data Available</div>;
    }
  return (
    <section>
      <div className="my-8 flex justify-between">
        {/* <WalletCard />
        <WalletCard />
        <WalletCard /> */}
      </div>
      <Panel>
        <Table>
          <RowHeader>
            <ColumnHeader>Description</ColumnHeader>
            <ColumnHeader>Transaction Date</ColumnHeader>
            <ColumnHeader>Amount</ColumnHeader>
            <ColumnHeader>Repayment Amount</ColumnHeader>
            <ColumnHeader>Status</ColumnHeader>
            <ColumnHeader>Action</ColumnHeader>
          </RowHeader>
          <Body data={paidLoanData}>
              {(data) =>
                data.map((item) => (
                  <Row key={item.id}>
                    <Column>{item.description}</Column>
                    <Column>
                      {moment(item.created_at).format(
                        "dddd, Do MMMM YYYY: h:mmA"
                      )}
                    </Column>
                    <Column>{formatNaira(item?.approved_amount)}</Column>
                    <Column>{formatNaira(item?.repayment_amount)}</Column>
                    <Column>
                      <span classname="text-xs text-green-600 px-2 py-1 rounded-md bg-gray-50">
                        {item.request_status}
                      </span>
                    </Column>
                    <Column>
                      {" "}
                      <Dropdown
                        trigger={["click"]}
                        menu={{
                          items: [
                            {
                              key: "1",
                              label: (
                                <Link
                                  to={`/dashboard/loan/disburse/${item.id}`}
                                  className="flex items-center justify-start space-x-1 text-sm font-medium focus:border-none focus:outline-none"
                                >
                                  <span>View More</span>
                                </Link>
                              ),
                            },
                          ],
                        }}
                        placement="bottomRight"
                        arrow={{ pointAtCenter: true }}
                      >
                        <div className="flex cursor-pointer items-center gap-x-1">
                          <BsThreeDots />
                        </div>
                      </Dropdown>
                    </Column>
                  </Row>
                ))
              }
            </Body>
        </Table>
        <div className="mt-2 flex items-center justify-between">
          <PageSize numbers={[5, 10, 20, 50]} />
          <Pagination>
            <>
              <Prev
                onClick={() => {
                  setPage(1);
                }}
              />
              {Array(data?.loanrequests?.data?.last_page)
                .fill(5)
                .map((v, i) => {
                  return (
                    <Button
                      key={i}
                      isActive={
                        data?.loanrequests?.data?.current_page === i + 1
                      }
                      onClick={() => {
                        setPage(i + 1);
                      }}
                    >
                      {i + 1}
                    </Button>
                  );
                })}
              <Next
                onClick={() => {
                  setPage(data?.loanrequests?.data?.last_page);
                }}
              />
            </>
          </Pagination>
        </div>
      </Panel>
    </section>
  );
};

export default LoanDibursed;

const WalletCard = () => {
  return (
    <div className="w-1/4 rounded-2xl bg-white py-8 shadow">
      <div className="flex items-center justify-center gap-x-6">
        <div className="flex h-10 w-10 items-center justify-center  rounded-full bg-fedacash-header">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
          >
            <path
              fill="#fff"
              d="m2.682 5.077.73.372-.73-.372Zm.728-.729.372.73-.372-.73Zm0 11.303.372-.73-.372.73Zm-.728-.728-.731.373.73-.373Zm14.636 0-.73-.372.73.372Zm-.728.729-.372-.731.372.73Zm.729-10.575-.731.372.73-.372Zm-.73-.729.373-.73-.372.73ZM5.834 11.68a.82.82 0 0 0 0 1.64v-1.64Zm3.334 1.64a.82.82 0 1 0 0-1.64v1.64ZM2.5 8.346a.82.82 0 1 0 0 1.64v-1.64Zm15 1.64a.82.82 0 0 0 0-1.64v1.64ZM2.5 6.68a.82.82 0 1 0 0 1.64V6.68Zm15 1.64a.82.82 0 0 0 0-1.64v1.64Zm-.82-1.487v6.333h1.64V6.833h-1.64Zm-1.846 8.18H5.167v1.64h9.667v-1.64ZM3.32 13.166V6.833H1.68v6.333h1.64Zm1.847-8.18h9.666v-1.64H5.168v1.64ZM3.32 6.834c0-.48 0-.791.02-1.028.019-.227.05-.313.072-.356l-1.461-.745c-.16.313-.219.64-.246.968-.026.319-.025.708-.025 1.161h1.64Zm1.847-3.487c-.453 0-.843 0-1.162.026-.328.027-.654.086-.967.245l.744 1.462c.043-.022.13-.054.357-.072.237-.02.548-.02 1.028-.02v-1.64ZM3.412 5.45a.846.846 0 0 1 .37-.37l-.744-1.462c-.469.239-.849.62-1.087 1.087l1.461.745Zm1.755 9.564c-.48 0-.791 0-1.028-.02-.228-.018-.314-.05-.357-.072l-.744 1.461c.313.16.639.219.967.246.32.026.709.025 1.162.025v-1.64ZM1.68 13.166c0 .454 0 .843.025 1.162.027.329.086.654.246.968l1.461-.745c-.022-.043-.053-.13-.072-.357-.02-.236-.02-.547-.02-1.028H1.68Zm2.102 1.755a.846.846 0 0 1-.37-.37l-1.461.745c.238.467.618.848 1.087 1.086l.744-1.461Zm12.898-1.755c0 .48 0 .792-.02 1.028-.018.228-.05.314-.072.357l1.461.745c.16-.314.219-.64.246-.968.026-.32.025-.708.025-1.162h-1.64Zm-1.846 3.487c.453 0 .842 0 1.16-.025.33-.027.655-.086.968-.246l-.744-1.461c-.044.022-.13.054-.357.072-.237.02-.547.02-1.027.02v1.64Zm1.754-2.102a.847.847 0 0 1-.37.37l.744 1.461a2.487 2.487 0 0 0 1.087-1.087l-1.461-.744Zm1.732-7.718c0-.453 0-.842-.025-1.161-.027-.329-.086-.655-.246-.968l-1.461.745c.022.043.053.129.072.356.02.237.02.548.02 1.028h1.64Zm-3.486-1.846c.48 0 .79 0 1.027.02.227.018.313.05.357.072l.744-1.462c-.313-.16-.639-.218-.967-.245-.32-.026-.708-.026-1.161-.026v1.64Zm3.215-.283a2.487 2.487 0 0 0-1.087-1.087l-.744 1.462c.16.081.289.21.37.37l1.461-.745ZM5.833 13.32h3.334v-1.64H5.833v1.64ZM2.5 9.987h15v-1.64h-15v1.64Zm0-1.667h15V6.68h-15v1.64Z"
            />
          </svg>
        </div>
        <div className="inline-flex flex-col items-start justify-start gap-0.5">
          <div className="text-neutral-950 text-3xl font-bold">₦1,200,000</div>
          <div className="text-slate-500 text-lg font-normal leading-relaxed">
            Total Loan Issued
          </div>
        </div>
      </div>
    </div>
  );
};
